import {
  Button,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
  HStack,
  useToast,
  Spinner,
  Select as ChakraSelect,
  Heading,
  Box,
  Container,
  useColorModeValue,
  Flex,
  Icon
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import Empty from "../../components/Empty";
import OtpHistoryCard from "../../components/OtpHistoryCard";
import { GetOtpHistoryAPI } from "../../utils/api";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { FiClock, FiFilter } from "react-icons/fi";

const DurationData = [
  { label: 'All time', value: 'all' },
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 days', value: 'lastWeek' },
  { label: 'Last 30 days', value: 'lastMonth' },
];

const OtpHistory = () => {
  const { Token, signupUser } = useContext(AppContext);
  const [pageNo, setPageNo] = useState(1);
  const [limitNo, setLimitNo] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [durationFilter, setDurationFilter] = useState('all');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cancelBtnRequestInProgress, setCancelBtnRequestInProgress] = useState(false);

  // Premium UI Colors
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.800", "white");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const tableHeaderBg = useColorModeValue("brand.500", "brand.600");

  useEffect(() => {
    setLoading(false);
    GetOtpHistoryAPI(Token, pageNo, limitNo, durationFilter)
      .then((res) => {
        setLoading(true);
        setData(res.data.data);
        setTotalPages(res.data.total_pages);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err, "error message");
      });
  }, [limitNo, pageNo, durationFilter]);

  const handleOTPCancel = (cancelId) => {
    let currentData = data;
    currentData = currentData.map((el) => {
      if (el._id == cancelId) {
        el.status = 'cancelled';
      };
      return el;
    });
    setData([...currentData]);
  };

  const handleOTPMessage = (mobileId, otpMessage) => {
    let currentData = data;
    currentData = currentData.map((el) => {
      if (el._id == mobileId) {
        el.status = 'success';
        el.otpIds = [...el.otpIds, { otpMessage }];
      };
      return el;
    });
    setData([...currentData]);
  };

  const handleChange = (event) => {
    console.log(event.value)
    setDurationFilter(event.value);
  };

  // Custom Select Styles Variables
  const selectBg = useColorModeValue("white", "#2D3748");
  const selectBorder = useColorModeValue("#E2E8F0", "#4A5568");
  const selectHoverBorder = "#3182ce";
  const selectOptionSelectedBg = useColorModeValue("#3182ce", "#3182ce");
  const selectOptionFocusedBg = useColorModeValue("#EBF8FF", "#2C5282");
  const selectOptionColor = useColorModeValue("#2D3748", "white");
  const selectSingleValueColor = useColorModeValue("#2D3748", "white");

  // Custom styles for React Select
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: selectBg,
      borderColor: selectBorder,
      borderRadius: "0.5rem",
      padding: "2px",
      boxShadow: state.isFocused ? "0 0 0 1px #3182ce" : "none",
      "&:hover": {
        borderColor: selectHoverBorder
      }
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: selectBg,
      zIndex: 10
    }),
    singleValue: (provided) => ({
      ...provided,
      color: selectSingleValueColor,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? selectOptionSelectedBg
        : state.isFocused
          ? selectOptionFocusedBg
          : "transparent",
      color: state.isSelected ? "white" : selectOptionColor,
    })
  };

  return (
    <>
      <Helmet>
        <title>Otp History | Techy India</title>
      </Helmet>
      <VStack
        w="100%"
        minH="100vh"
        bg={bg}
        spacing={0}
        align="stretch"
        py={8}
      >
        <Container maxW="container.xl">
          <VStack spacing={8} align="stretch">
            {/* Header Section */}
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "start", md: "center" }}
              gap={4}
            >
              <VStack align="start" spacing={1}>
                <Heading size="lg" color={textColor}>
                  OTP <Text as="span" color="brand.500">History</Text>
                </Heading>
                <Text color="gray.500" fontSize="sm">
                  View and manage your OTP requests
                </Text>
              </VStack>

              <HStack w={{ base: "100%", md: "300px" }}>
                <Box w="100%">
                  <Select
                    onChange={handleChange}
                    required={true}
                    defaultValue={DurationData[0]}
                    options={DurationData}
                    styles={customSelectStyles}
                    placeholder="Filter by duration"
                    isSearchable={false}
                  />
                </Box>
              </HStack>
            </Flex>

            {/* Content Section */}
            <Box
              bg={cardBg}
              rounded="2xl"
              shadow="sm"
              border="1px solid"
              borderColor={borderColor}
              overflow="hidden"
              minH="60vh"
            >
              {!loading && (
                <Flex justify="center" align="center" h="400px">
                  <Spinner
                    thickness="4px"
                    speed="0.65s"
                    emptyColor="gray.200"
                    color="brand.500"
                    size="xl"
                  />
                </Flex>
              )}

              {data.length > 0 && loading && (
                <TableContainer w="100%">
                  <Table variant="simple">
                    <Thead bg={tableHeaderBg}>
                      <Tr>
                        <Th color="white" py={5} textAlign="center">Action</Th>
                        <Th color="white" py={5} textAlign="center">Service</Th>
                        <Th color="white" py={5} textAlign="center">Price</Th>
                        <Th color="white" py={5} textAlign="center">Mobile</Th>
                        <Th color="white" py={5} textAlign="center">Status</Th>
                        <Th color="white" py={5} textAlign="center">OTP</Th>
                        <Th color="white" py={5} textAlign="center">Date</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data?.map((el) => (
                        <OtpHistoryCard
                          key={el._id}
                          serviceName={el?.serviceId?.serviceName || ""}
                          otpMessages={el.otpIds}
                          createdAt={el.createdAt}
                          time={el.time}
                          price={el.price}
                          status={el.status}
                          mobile={el.mobileno}
                          mobileId={el._id}
                          serialNumber={el?.serialNumber || ""}
                          handleOTPCancel={handleOTPCancel}
                          handleOTPMessage={handleOTPMessage}
                          server={el?.serviceId?.server}
                          businessCode={el?.serviceId?.serviceCode}
                          cancelBtnRequestInProgress={cancelBtnRequestInProgress}
                          setCancelBtnRequestInProgress={setCancelBtnRequestInProgress}
                        />
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              )}

              {!data.length && loading && (
                <Empty title={"No OTP history found"} />
              )}
            </Box>

            {/* Pagination */}
            {totalPages > 1 && (
              <Flex justify="space-between" align="center" direction={{ base: "column", sm: "row" }} gap={4}>
                <HStack>
                  <Text fontSize="sm" color="gray.500">Rows per page:</Text>
                  <ChakraSelect
                    w="80px"
                    size="sm"
                    rounded="md"
                    onChange={(e) => {
                      setLimitNo(Number(e.target.value));
                      setPageNo(1);
                    }}
                    bg={cardBg}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={40}>40</option>
                    <option value={60}>60</option>
                    <option value={80}>80</option>
                    <option value={100}>100</option>
                  </ChakraSelect>
                </HStack>

                <HStack spacing={2}>
                  <Button
                    size="sm"
                    onClick={() => setPageNo((pre) => Math.max(pre - 1, 1))}
                    isDisabled={pageNo === 1}
                    variant="outline"
                    bg={cardBg}
                  >
                    Previous
                  </Button>
                  <Flex
                    align="center"
                    justify="center"
                    bg="brand.500"
                    color="white"
                    w="32px"
                    h="32px"
                    rounded="md"
                    fontSize="sm"
                    fontWeight="bold"
                  >
                    {pageNo}
                  </Flex>
                  <Text color="gray.500" fontSize="sm">of {totalPages}</Text>
                  <Button
                    size="sm"
                    onClick={() => setPageNo((pre) => Math.min(pre + 1, totalPages))}
                    isDisabled={pageNo === totalPages}
                    variant="outline"
                    bg={cardBg}
                  >
                    Next
                  </Button>
                </HStack>
              </Flex>
            )}
          </VStack>
        </Container>
      </VStack>
    </>
  );
};

export default OtpHistory;